/*
 * Copyright (c) 2020.
 * Simon
 */

import React, {Component} from 'react';
import {Button} from "reactstrap";
import i18n from "i18next";

class ApiButtons extends Component {

    constructor(props) {
        super(props);
        this.state = {
            buttonText: this.props.text,
            buttonHelp: this.props.helpText,
        };
    }

    render() {
        return (
            <span>
                <Button
                    className={"ApiButton"}
                    id={this.props.id}
                    color={this.props.color}
                    size={this.props.size}
                    onClick={this.props.onClick}
                >
                    <div className="send-load">
                        {i18n.t(this.state.buttonText)}
                    </div>
                </Button>

                {this.state.buttonHelp !== undefined ?
                    <span className={'small text-muted'}> {i18n.t(this.state.buttonHelp)}</span> : ''}
            </span>
        );
    }
}

export default ApiButtons;
